import { C } from '../data/constants.js';

export class Ball {
  constructor() {
    this.x = C.CANVAS_W / 2;
    this.y = C.PADDLE_Y - C.PADDLE_H / 2 - C.BALL_RADIUS - 1;
    this.vx = 0;
    this.vy = 0;
    this.radius = C.BALL_RADIUS;
    this.speed = C.BALL_SPEED;
    this.attached = true;  // stuck to paddle before launch
    this.alive = true;
    
    // Trail history (array of {x, y} positions)
    this.trail = [];
  }

  attachTo(paddle) {
    this.x = paddle.x;
    this.y = paddle.top - this.radius - 1;
    this.attached = true;
    this.vx = 0;
    this.vy = 0;
  }

  launch(paddle) {
    if (!this.attached) return;
    this.attached = false;
    
    // Launch upward with slight angle based on paddle velocity
    const angle = -Math.PI / 2 + (paddle.velocity * 0.03);
    this.vx = Math.cos(angle) * this.speed;
    this.vy = Math.sin(angle) * this.speed;
  }

  update() {
    if (this.attached) return;
    
    // Store trail position
    this.trail.unshift({ x: this.x, y: this.y });
    if (this.trail.length > C.BALL_TRAIL_LENGTH) {
      this.trail.pop();
    }
    
    // Move
    this.x += this.vx;
    this.y += this.vy;
    
    // Wall collisions (left, right, top) — bounce off visible borders
    const wallLeft = C.BORDER_WIDTH;
    const wallRight = C.CANVAS_W - C.BORDER_WIDTH;
    const wallTop = C.HUD_HEIGHT + C.BORDER_WIDTH;

    if (this.x - this.radius <= wallLeft) {
      this.x = wallLeft + this.radius;
      this.vx = Math.abs(this.vx);
    }
    if (this.x + this.radius >= wallRight) {
      this.x = wallRight - this.radius;
      this.vx = -Math.abs(this.vx);
    }
    if (this.y - this.radius <= wallTop) {
      this.y = wallTop + this.radius;
      this.vy = Math.abs(this.vy);
    }
    
    // Bottom — ball lost (no border, falls off screen)
    if (this.y - this.radius > C.CANVAS_H) {
      this.alive = false;
    }
    
    // Clamp speed
    const currentSpeed = Math.sqrt(this.vx * this.vx + this.vy * this.vy);
    if (currentSpeed > C.BALL_MAX_SPEED) {
      const scale = C.BALL_MAX_SPEED / currentSpeed;
      this.vx *= scale;
      this.vy *= scale;
    }
    
    // Ensure ball always has minimum downward or upward velocity
    // to prevent horizontal-only bouncing
    if (Math.abs(this.vy) < 0.5) {
      this.vy = this.vy >= 0 ? 0.5 : -0.5;
    }
  }

  render(ctx, isFireball = false) {
    if (isFireball) {
      // Draw Fiery Flame Trail
      for (let i = 0; i < this.trail.length; i++) {
        const t = this.trail[i];
        const progress = 1 - i / this.trail.length;
        const alpha = progress * 0.6;
        const r = this.radius * (0.8 + progress * 0.7);
        ctx.beginPath();
        ctx.arc(t.x, t.y, r, 0, Math.PI * 2);
        ctx.fillStyle = i < 3 ? `rgba(255, 230, 80, ${alpha})` : (i < 7 ? `rgba(255, 100, 0, ${alpha})` : `rgba(200, 20, 0, ${alpha * 0.6})`);
        ctx.fill();
      }

      // Draw Fireball Outer Corona
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius + 3, 0, Math.PI * 2);
      ctx.fillStyle = '#ff4400';
      ctx.shadowColor = '#ff2200';
      ctx.shadowBlur = 18;
      ctx.fill();

      // Draw Fireball Inner Incandescent Core
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
      ctx.fillStyle = '#ffff66';
      ctx.shadowColor = '#ffaa00';
      ctx.shadowBlur = 8;
      ctx.fill();
      ctx.shadowBlur = 0;
      return;
    }

    // Draw normal trail
    for (let i = 0; i < this.trail.length; i++) {
      const t = this.trail[i];
      const alpha = (1 - i / this.trail.length) * 0.4;
      const r = this.radius * (1 - i / this.trail.length * 0.5);
      ctx.beginPath();
      ctx.arc(t.x, t.y, r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(255, 255, 255, ${alpha})`;
      ctx.fill();
    }
    
    // Draw ball
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
    ctx.fillStyle = C.BALL_COLOR;
    ctx.shadowColor = C.BALL_COLOR;
    ctx.shadowBlur = 10;
    ctx.fill();
    ctx.shadowBlur = 0;
  }
}
